import RSVP from 'rsvp';
import $ from 'jquery';
import _ from 'underscore';
import SessionStore from 'stores/shared/session';

const ConversationService = {
  create_from_booking(params) {
    params = _.extend(params, SessionStore._getCSRFTokenObject());

    return new RSVP.Promise((resolve, reject) => {
      const url = '/conversations/create_from_booking';
      $.ajax({
        type: 'POST',
        url,
        data: params,
        success: resolve,
        error: reject,
      });
    });
  },
};

export default ConversationService;
